import { ApexOptions } from 'apexcharts'
import { ApexChart } from '../ApexChart'
import { makeStyles } from '@material-ui/core'
import { strings } from '../strings'
import { StabilityCounts } from './Util'

interface Props {
  stabilityCounts: StabilityCounts
}
export function UptimePieChart({ stabilityCounts }: Props) {
  const classes = useStyles()

  const { optimal, acceptable, weak, veryWeak, withoutConnection } =
    stabilityCounts

  const options: ApexOptions = {
    series: [optimal, acceptable, weak, veryWeak, withoutConnection],
    chart: {
      width: 380,
      type: 'pie',
      fontFamily: 'vazir',
      animations: {
        enabled: false,
      },
    },
    labels: [
      strings.optimal,
      strings.acceptable,
      strings.weak,
      strings.veryWeak,
      strings.withoutConnection,
    ],
    legend: {
      show: false,
    },
    colors: ['#198D10', '#A1BC12', '#EE3B3B', '#B00C0C', '#5F6368'],
  }

  return (
    <div className={classes.root}>
      <ApexChart options={options} />
    </div>
  )
}

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 'fit-content',
  },
}))
